import React, { useState, useEffect } from 'react';
import { API_CONFIG } from '../../config/api';
import './TopBar.css';

interface Country {
  id: number;
  code: string;
  name: string;
}

const TopBar: React.FC = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

  useEffect(() => {
    fetchCountries();
    // Load selected country from localStorage
    const cachedCountry = localStorage.getItem('selectedCountry');
    if (cachedCountry) {
      setSelectedCountry(JSON.parse(cachedCountry));
    }
  }, []);

  const fetchCountries = async () => {
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/admin/countries/recent`);
      if (!response.ok) {
        throw new Error('Failed to fetch countries');
      }
      const data = await response.json();
      setCountries(data);
      
      // If no country is selected, select the first one
      if (!selectedCountry && data.length > 0) {
        handleCountryChange(data[0]);
      }
    } catch (err) {
      console.error('Error fetching countries:', err);
    }
  };

  const handleCountryChange = (country: Country) => {
    setSelectedCountry(country);
    localStorage.setItem('selectedCountry', JSON.stringify(country));
    
    // Dispatch custom event for other components to listen
    const event = new CustomEvent('countryChanged', { detail: country });
    window.dispatchEvent(event);
  };

  return (
    <div className="top-bar">
      <div className="top-bar-title">
        <h1>KurzNews Admin</h1>
      </div>
      <div className="country-selector">
        <select
          value={selectedCountry?.id || ''}
          onChange={(e) => {
            const country = countries.find(c => c.id === parseInt(e.target.value));
            if (country) {
              handleCountryChange(country);
            }
          }}
        >
          {countries.map(country => (
            <option key={country.id} value={country.id}>
              {country.name} ({country.code})
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default TopBar; 